import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as html2canvas from "html2canvas"
import { NbWindowService, NbWindowState, NbDialogService } from '@nebular/theme';
import { EmailService } from "../../../@core/api/email.service"
import { ConfirmDialogComponent } from '../../utils/confirm-dialog/confirm-dialog.component'
import { Email } from '../../../@core/data/email';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-email-row',
  templateUrl: './email-row.component.html',
  styleUrls: ['./email-row.component.scss']
})
export class EmailRowComponent implements OnInit {

  @Input() email: Email;
  @Output() updateList = new EventEmitter();


  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private emailService: EmailService,
  ) { }

  async ngOnInit() {
    
  }


  show(type) {

    switch (type) {
      case "edit":
        this.router.navigate(["home", "email", this.email.id])
        break;
      case "preview":
        this.showPreview()
        break;
      case "download":
        this.exportHtml()
        break;
      case "copy":
        this.copyEmail()
        break;

      case "delete":
        this.dialogService.open(ConfirmDialogComponent, { context: { operation: "eliminare " + this.email.name } })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteEmail()
            }
          })
        break;
    }

  }

  async copyEmail() {
    let email = this.email
    email.name = email.name + " (Copia)"
    let res = <any>await this.emailService.createEmail(email);
    this.updateList.emit()
  }

  showPreview() {
    let url = "/l/" + this.email.id
    window.open(url, '_blank').focus();
  }


  async exportHtml() {
    downloadURI("data:text/html," + encodeURIComponent(this.email.html), this.email.name + ".html")
  }


  async DeleteEmail() {
    await this.emailService.deleteEmail(this.email.id);
    this.updateList.emit();

  }

}

function downloadURI(dataurl, filename) {
  const link = document.createElement("a");
  link.href = dataurl;
  link.download = filename;
  link.click();
}
